import { ManagedReceivingGlobalApi as Api } from "@capstone/mock-api";

export class ODataReference {
  public constructor(public readonly id: string) {}

  public serialize(): Api.ODataReference {
    return { "@odata.id": this.id };
  }
}
